import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const person = new Restful(project, 'person')

person.getUser = function(data) {
  const url = project + 'person/user'
  return http.get(url, data).then(res => {
    return res
  })
}

// display修改
person.editDisplay = function(id, data) {
  const url = project + 'person/display/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

// reviewer修改
person.editReviewer = function(id, data) {
  const url = project + 'person/reviewer/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

person.editJournal = function(id, data) {
  const url = project + 'person/journal/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

person.rmanuscript = function(id, data) {
  const url = project + 'person/rmanuscript/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

person.icon = function(id, data) {
  const url = project + 'person/icon/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

person.submit = function(id, data) {
  const url = project + 'person/submit/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

person.special = function(id, data) {
  const url = project + 'person/special/' + id
  return http.get(url, data).then(res => {
    return res
  })
}
// GE
person.guest = function(id, data) {
  const url = project + 'person/guest/editor/' + id
  return http.get(url, data).then(res => {
    return res
  })
}
// Hindex
person.hindex = function(id, data) {
  const url = project + 'person/hindex/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

person.checkEmail = function(email, data) {
  const url = project + 'person/flag/email/' + email
  return http.get(url, data).then(res => {
    return res
  })
}

export default person
